import React from 'react';
import { LinearProgress, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ScoreBarProps {
  category: string;
  score: number;
}

const getColor = (score: number): string => {
  if (score < 30) return '#CD4829';
  if (score < 70) return '#F8A044';
  return '#369980';
};

const StyledLinearProgress = styled(LinearProgress)(({ score }: { score: number }) => ({
  height: '10px',
  borderRadius: '5px',
  backgroundColor: '#e0e0e0',
  '& .MuiLinearProgress-bar': {
    backgroundColor: getColor(score),
  },
}));

const ScoreBar: React.FC<ScoreBarProps> = ({ category, score }) => (
  <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
    <Typography variant="body1" sx={{ minWidth: '150px' }}>
      {category}:
    </Typography>
    <Box sx={{ flexGrow: 1, mr: 1 }}>
      <StyledLinearProgress variant="determinate" value={(score / 100) * 100} score={score} />
    </Box>
    <Typography variant="body1">{score.toFixed(1)}</Typography>
  </Box>
);

export default ScoreBar;
